// These are the magic strings coming from the backend
// we can use them to map to our own enum value
const UNKNOWN = 'Unknown'
const BOX = 'Box'
const BUBBLE_MAILER = 'BubbleMailer'
const POLY_MAILER = 'PolyMailer'
const FRAGILE_BOX = 'FragileBox'
const POSTER_TUBE = 'PosterTube'
const CUSTOM_PACKAGING = 'Custom'
const BOOKFOLD_LARGE = 'Bookfold'
const SHIP_IN_OWN_CONTAINER = 'OwnContainer'

// enum mapping to the proper i18n text
export const PackageMaterialTypeEnum = {
  default: 'packageMaterialType.Unknown',
  [UNKNOWN]: 'packageMaterialType.Unknown',
  [BOX]: 'packageMaterialType.Box',
  [BUBBLE_MAILER]: 'packageMaterialType.BubbleMailer',
  [POLY_MAILER]: 'packageMaterialType.PolyMailer',
  [FRAGILE_BOX]: 'packageMaterialType.FragileBox',
  [POSTER_TUBE]: 'packageMaterialType.PosterTube',
  [CUSTOM_PACKAGING]: 'packageMaterialType.CustomPackaging',
  [BOOKFOLD_LARGE]: 'packageMaterialType.BookfoldLarge',
  [SHIP_IN_OWN_CONTAINER]: 'packageMaterialType.ShipInOwnContainer'
}
